<template>
  <div 
    v-if="visible"
    role="alert" 
    :class="[
      'tw-w-full tw-p-4 tw-mb-4 tw-rounded-lg tw-animate-fade-in-up tw-text-[inherit] tw-border-solid tw-border-thin',
      typeClasses[type]
    ]"
  >
    <template>
      <div class="tw-flex tw-justify-between tw-items-center">
        <span v-if="icon" class="tw-text-2xl tw-mr-3 tw-inline-flex tw-items-center">
          <i :class="[iconType, icon, textClasses[type]]"></i>
        </span>
        <slot>
          <span v-if="$slots.text">
            <slot name="text"></slot>
          </span>
        </slot>
        <div
          v-if="dismissible"
          role="button" 
          data-dismiss="alert"
          aria-label="Close"
          class="tw-cursor-pointer tw-px-2 tw-py-1"
          @click="dismissAlert"
        >
          <span aria-hidden="true" class="tw-text-2xl">
            <i class="fas fa-times" :class="textClasses[type]"/>
          </span>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: "tw-base-alert",
  props: {
    type: {
      type: String,
      default: "default",
      description: "Alert type"
    },
    icon: {
      type: String,
      default: "",
      description: "Alert icon. Will be overwritten by default slot"
    },
    iconType: {
      type: String,
      default: "fas",
      description: "Alert icon type. fas|far"
    },
    dismissible: {
      type: Boolean,
      default: false,
      description: "Whether alert is closes when clicking"
    }
  },
  data() {
    return {
      visible: true,
      typeClasses: {
        default: "tw-bg-gray-100 tw-border-gray-500",
        primary: "tw-bg-blue-100 tw-border-blue-500",
        success: "tw-bg-green-100 tw-border-green-500",
        danger: "tw-bg-red-100 tw-border-red-500",
        warning: "tw-bg-amber-100 tw-border-amber-500",
        info: "tw-bg-indigo-100 tw-border-indigo-500"
      },
      textClasses: {
        default: "tw-text-gray-500",
        primary: "tw-text-blue-500",
        success: "tw-text-green-500",
        danger: "tw-text-red-500",
        warning: "tw-text-amber-500",
        info: "tw-text-indigo-500"
      }
    };
  },
  methods: {
    dismissAlert() {
      this.visible = false;
    }
  }
};
</script>